







































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import SsoDeepLink from "@/shared/components/ui/SsoDeepLink.vue";
import {
  HsaBankStatementListItem,
  HsaBankTaxDocumentListItem,
  FetchState,
  HsabDocumentType,
  HsabSsoDestination
} from "@/shared/types";
import moment from "moment";
import _ from "lodash";
import { useHsaBankTaxDocumentsStore } from "@/employee/store/hsaBankTaxDocuments";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { docTypeIconMap } from "@/shared/awesomeIconMapper";

interface DocumentItem {
  dateGenerated: moment.Moment;
  linkTitle: string;
  downloadAction: () => Promise<any>;
  key: string;
  isLoading: boolean;
  isDisabled: boolean;
  docType: HsabDocumentType;
}

@Component({
  components: {
    GenericLoadingSpinner,
    SsoDeepLink
  }
})
export default class TaxDocumentsAllYears extends Vue {
  docTypeIconMap = docTypeIconMap;
  hsaBankTaxDocumentsStore = useHsaBankTaxDocumentsStore();
  featureFlagStore = useFeatureFlagStore();
  HsabDocumentType = HsabDocumentType;

  get isLoading () {
    return this.featureFlagStore.featureFlagsAvailable === false ||
      this.hsaBankTaxDocumentsStore.isPageDocumentsLoaded === false;
  }

  get hasTaxDocuments (): boolean {
    return this.documentItems.length > 0;
  }
  get documentItems () {
    return this.hsaBankTaxDocumentsStore.taxDocumentsForYear
      .map(this.mapTaxDocumentItem);
  }
  mapTaxDocumentItem (item: HsaBankTaxDocumentListItem): DocumentItem {
    const dateGenerated = moment(item.dateGenerated);
    const linkTitle = `${item.taxYear} ${item.title}`;
    const openTaxDocumentMethod = this.hsaBankTaxDocumentsStore.openTaxDocumentLocation;

    const downloadAction = () => openTaxDocumentMethod({
      identifier: item.identifier,
      linkTitle
    });

    return {
      dateGenerated,
      downloadAction,
      linkTitle,
      key: `${item.title}-${dateGenerated.format()}`,
      isLoading: this.hsaBankTaxDocumentsStore.taxDocumentPdfs[item.identifier].fetchState === FetchState.Loading ||
        this.hsaBankTaxDocumentsStore.taxDocumentLocations[item.identifier].fetchState === FetchState.Loading,
      isDisabled: false,
      docType: HsabDocumentType.Tax
    };
  }
  onDownloadClick (item: DocumentItem) {
    item.downloadAction();
  }
  mounted () {
    this.loadPage();
  }
  loadPage () {
    this.hsaBankTaxDocumentsStore.loadTaxDocumentsForAllYears();
  }
}

